import { MultipartFailureKind } from '@atlas/types'
import type { UploadRecovery } from './upload-recovery'
import { MultipartUploadError } from './uploader/multipart/multipart-errors'

export { type UploadRecovery, UploadRecoveryAction } from './upload-recovery'

/**
 * The recovery offer a failed upload carries, or `null` when it has none.
 *
 * Deliberately a lookup rather than a decision: the transport already chose the
 * actions at the point it knew what the server session was doing, and this
 * reads them off. Anything the manager cannot recognize — a network error, a
 * single-PUT failure, a consumer's own throw — carries no offer, which is the
 * pre-Ticket-91 behavior for every one of them.
 */
export function recoveryFrom(error: unknown): UploadRecovery | null {
	if (!(error instanceof MultipartUploadError)) return null
	const actions = error.context.actions ?? []
	if (actions.length === 0) return null
	return {
		actions,
		// `retryable` is the one kind whose session is still alive on the server;
		// every other stopped outcome has ended the upload.
		terminal: error.kind !== MultipartFailureKind.RETRYABLE,
		...(error.context.releaseSession ? { releaseSession: error.context.releaseSession } : {}),
	}
}
